// assets/search-autofocus.js
(function () {
  'use strict';

  const SEARCH_TOGGLE_SELECTOR = '[data-action="toggle-search"]';
  const SEARCH_CONTAINER_SELECTOR = '#Search';
  const SEARCH_INPUT_SELECTOR = '#SearchInput';

  function isSearchOpen(container) {
    if (!container) return false;

    // Common Shopify patterns
    if (container.getAttribute('aria-hidden') === 'false') return true;
    if (container.classList.contains('is-visible')) return true;

    return false;
  }

  function focusSearchInput() {
    const input = document.querySelector(SEARCH_INPUT_SELECTOR);
    if (!input) return false;

    // Ensure input is actually visible
    const rect = input.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0) return false;

    input.focus();
    input.setSelectionRange(input.value.length, input.value.length);
    return true;
  }

  function waitForSearchAndFocus() {
    const container = document.querySelector(SEARCH_CONTAINER_SELECTOR);
    if (!container) return;

    let attempts = 0;
    const maxAttempts = 20;

    const interval = setInterval(() => {
      attempts++;

      if (isSearchOpen(container) && focusSearchInput()) {
        clearInterval(interval);
      }

      if (attempts >= maxAttempts) {
        clearInterval(interval);
      }
    }, 50);
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest(SEARCH_TOGGLE_SELECTOR);
    if (!toggle) return;

    // Let the theme open the search first
    setTimeout(waitForSearchAndFocus, 0);
  });
})();